import { CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList,
} from "recharts";

export default function WeightBandChart({
  width = 600,
  height = 300,
  graphData = [],
}) {
  const [data, setData] = useState([]);
  // Define colors for the chart segments

  useEffect(() => {
    console.log("graphData", graphData);
    setData([
      ...graphData.map((d) => {
        return { ...d, value: parseInt(d.value) };
      }),
    ]);
  }, [graphData]);

  return data.length > 1 ? (
    <div>
      <BarChart width={width} height={height} data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="weightBand" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar
          dataKey="bodyCount"
          fill="var(--primary-blue-color)"
          barSize={35} // Change the width of the bars
        ></Bar>
      </BarChart>
    </div>
  ) : (
    <div> No Data</div>
  );
}
